import React, { useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { Box, Button, VStack, Heading, Span, Text } from '@bpba/ui-components';
import { useLocation } from "react-router-dom";
import axios from 'axios';
import { Result } from './Result';
import { ResultExito } from './ResultExito';
import { ResultError } from './ResultError';
import { useNavigate } from 'react-router-dom';
import { ArchivosArrayModel } from '../rest/models/ArchivosArrayModel';

interface propState {
    nroSolicitud: string;
    masDeUnArchivo?: string;
    formularioId?:string;
}

const FileUploadComponent: React.FC = () => {

    const location = useLocation();
    let { nroSolicitud, masDeUnArchivo,formularioId } = location.state as propState;

    const { register, handleSubmit, clearErrors, reset, setValue, formState: { errors, isSubmitting } } = useForm<any>({
        mode: 'onChange',
        criteriaMode: 'all',
        reValidateMode: 'onChange',
        defaultValues: {
            contenido: ''
        }
    });
    const [contadorSubida, setcontadorSubida] = useState<number>(1);
    const [showAgregarArchivo, setShowAgregarArchivo] = useState<boolean>(false);
    const REQUIRED_FIELD = "Campo requerido.";
    const [mensajeError, setMensajeError] = useState<string>("");
    const [errorServicio, setErrorServicio] = useState<boolean>(false);

    const [mensajeRtaServicio, setMensajeRtaServicio] = useState<string>("");
    const [servicioOk, setServicioOk] = useState<boolean>(false);
    const [mensajeErrorPostProspecto, setMensajeErrorPostProspecto] = useState<string>("");
    const [fileType, setFileType] = useState<string>("");
    const navigate = useNavigate();
    const [fileNamesProcessed, setFileNamesProcessed] = useState<string[]>([]);

    const arrayName = ["Escaneando..", 'Obteniendo resultados..', 'Comprimiendo..', 'Subiendo..'];

    const [count, setCount] = useState(0)


    const onSubmit: SubmitHandler<ArchivosArrayModel> = async (data: ArchivosArrayModel) => {

        let innerCounter = 0;
        const interval = setInterval(() => {
            if (innerCounter === arrayName.length) {

            } else {
                setCount(innerCounter);
                innerCounter++;
            }
        }, 5000);



        const formdata = new FormData();
        formdata.append("file", data.contenido[0]);

        let url = "/gateway/upload/files?systemId=1&correlatedId=" + nroSolicitud;

        if (fileType === 'application/pdf'
            || fileType === "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        ) {
            url = "/gateway/files/";
            await axios.post(url, formdata).then(async (res) => {//valido pdf/word
                
                if (res.status === 200) {
                    url = "/gateway/upload/files?systemId=1&correlatedId=" + nroSolicitud;
                    await axios.post(url, formdata).then((res) => {//si es un archivo válido llamo a la api de forti para hacer el upload
                        clearInterval(interval);
                        
                        if (res.status === 200) {
                            
                            setFileNamesProcessed(res.data.filenames);
                            if (masDeUnArchivo) {
                                setcontadorSubida(contadorSubida + 1);
                                if (contadorSubida === 5) {
                                    setShowAgregarArchivo(false)
                                    setServicioOk(true)
                                    setMensajeRtaServicio("Documentos adjuntados con éxito. En los próximos días nos contactaremos con vos.");
                                } else if (contadorSubida < 5) {
                                    setShowAgregarArchivo(true);
                                }
                            } else {
                                setServicioOk(true);
                                setMensajeRtaServicio("Documento "+ res.data.fileName +" adjuntado con éxito. En los próximos días nos contactaremos con vos.");
                            }
                        } else {
                            setErrorServicio(true)
                            setMensajeError("Ha ocurrido un problema, inténtelo mas tarde.")
                        }

                    }).catch((e: any) => {
                        clearInterval(interval);

                        setServicioOk(false);
                        setMensajeErrorPostProspecto("Ha ocurrido un problema, inténtelo mas tarde.");

                    });
                }
            }).catch((e: any) => {
                clearInterval(interval);
                if (e.response.data.code === "409") {
                    setErrorServicio(true);
                    setMensajeError(e.response.data.message);

                } else {
                    setServicioOk(false);
                    setMensajeErrorPostProspecto("Ha ocurrido un problema, inténtelo mas tarde.");
                }

            });


        } else {
            await axios.post(url, formdata).then((res) => {
                clearInterval(interval);
                if (res.status === 200) {
                    setFileNamesProcessed(res.data.Filenames);
                    if (masDeUnArchivo) {
                        setcontadorSubida(contadorSubida + 1);
                        if (contadorSubida === 5) {
                            setShowAgregarArchivo(false)
                            setServicioOk(true)
                            setMensajeRtaServicio("Documentos adjuntados con éxito. En los próximos días nos contactaremos con vos.");
                        } else if (contadorSubida < 5) {
                            setShowAgregarArchivo(true);
                        }
                    } else {
                        setServicioOk(true);
                        setMensajeRtaServicio("Documento "+ res.data.fileName +" adjuntado con éxito. En los próximos días nos contactaremos con vos.");
                    }
                } else {
                    setErrorServicio(true)
                    setMensajeError("Ha ocurrido un problema, inténtelo mas tarde.")
                }

            }).catch((e: any) => {
                clearInterval(interval);
                setServicioOk(false);
                setMensajeErrorPostProspecto("Ha ocurrido un problema, inténtelo mas tarde.");
            });
        }

    };



    const uploadImage = (e: any) => {

        let file = e.target.files;

        if (file === undefined || file === null) {

            setErrorServicio(true)
            setMensajeError("no selecciono ningun archivo")

        } else {

            setFileType(file[0].type);


            if (file[0].type === "image/gif" || file[0].type === "image/jpg" || file[0].type === "image/jpeg" ||
                file[0].type === "image/png" || file[0].type === "text/plain" || file[0].type === "text/csv" ||
                file[0].type === "image/bmp" || file[0].type === "image/tiff"
                || file[0].type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                || file[0].type === "application/pdf"
            ) {
                setErrorServicio(false)
                clearErrors("contenido")
                if (file[0].size > 1e6) {
                    e.target.value = null
                    setErrorServicio(true)
                    setMensajeError("El tamaño del archivo es excesivo, por favor subir achivos menores a 1MB")
                }

            } else {
                e.target.value = null

                setErrorServicio(true)
                setMensajeError("El tipo de archivo que intenta subir no esta permitido. solo se aceptan los siguientes formatos: gif,jpg,jpeg,png,txt,csv,bmp,tiff,pdf,docx")
            }


        }
    }

    const handleReset = () => {
        reset({});
        navigate('/home/');
    };
    if (isSubmitting) return <Box justifyContent={"center"} flexDirection={"column"}>
        <Text textAlign={"center"}>{arrayName[count]}</Text>
    </Box>;

    if (showAgregarArchivo) return (
        <Box display={'flex'} flexDirection={"column"} marginTop={"15px"} alignItems={"center"}>
            <Heading level={4} mb={0} fontWeight={400} tabIndex={0}>
                Archivo subido con exito! <br /> <br /> Desea cargar otro archivo?
            </Heading>
            {formularioId==="formularioUnico" && <VStack mt={"20px"}>
            
                
                    <Span color="primary.0" fontSize={"12px"} tabIndex={0}>{'Archivos Procesados con Éxito: '}</Span>
                    {fileNamesProcessed && 
                    
                    fileNamesProcessed.map((fileProcessed) =>
                        <Span color="primary.1" fontSize={"12px"} tabIndex={0}>{'Archivo subido: '+fileProcessed}</Span>)
                    }
            </VStack>}
            
            <Button style={{ width: "fit-content", height: "calc(1.8em + 0.75rem + 2px)" }} id={`btn-+`} type="button" variant={'primary'} onClick={() => { setValue("contenido", null); setShowAgregarArchivo(false); }} py={'10px !important'}>Agregar archivo</Button>
            <Button type="button" variant="secondary" marginBottom={"24px"} style={{ height: "calc(1.8em + 0.75rem + 2px)" }} py={'10px !important'} onClick={() => { setShowAgregarArchivo(false); setServicioOk(true); setMensajeRtaServicio("En los próximos días nos contactaremos con vos.") }}>Finalizar</Button>

        </Box>
    );

    if (servicioOk) return (
        <Result handleReset={handleReset}>
            <ResultExito message={mensajeRtaServicio}></ResultExito>
        </Result>
    );
    if (mensajeErrorPostProspecto !== "" && !servicioOk) return (
        <Result handleReset={handleReset}>
            <ResultError message={mensajeErrorPostProspecto}></ResultError>
        </Result>

    );


    return (


        <Box>
            <VStack>
                <Heading level={3} mb={0} fontWeight={400} tabIndex={0}>
                    Carga de archivos
                </Heading>
                {errorServicio ?
                    <VStack mt={"20px"}>
                        <Span color="red" fontSize={"12px"} tabIndex={0}>
                            {mensajeError}
                        </Span>
                    </VStack> : <></>
                }
                <form onSubmit={handleSubmit(onSubmit)} >

                    <VStack mt={"10px"}>
                        <Box key={`archivos`} display={'flex'}>

                            <Box justifyContent={'space-between'} display={'flex'} flexDirection={'column'}>
                                <input {...register(`contenido`, { required: REQUIRED_FIELD })} type="file" onChange={(e) => uploadImage(e)} />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors && errors?.contenido ? "* " + errors.contenido.message : ""}</Span>

                            </Box>

                        </Box>
                    </VStack>

                    {masDeUnArchivo ?
                        <VStack>
                            <VStack>
                                <Text fontSize={"22px"} lineHeight={"27px"} fontWeight={"400"} color={"primary.0"}>{mensajeRtaServicio}</Text>
                                <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                                    <VStack mr={"0.5rem"}>
                                        <Button
                                            type="submit" variant="secondary"

                                            py={"10px !important"}
                                            style={{
                                                width: "100%",
                                                height: "calc(1.8em + 0.75rem + 2px)"
                                            }}
                                        >
                                            Adjuntar
                                        </Button>
                                    </VStack>
                                    <VStack mr={"0.5rem"}>
                                        <Button
                                            onClick={() => { setServicioOk(true); setMensajeRtaServicio("En los próximos días nos contactaremos con vos."); }}
                                            variant="secondary"
                                            py={"10px !important"}
                                            style={{
                                                width: "100%", backgroundColor: "white",
                                                borderRadius: "3px 8px 3px 8px",
                                                border: "solid 2px", borderColor: "#3c3c3b",
                                                color: "#3c3c3b",
                                                height: "calc(1.8em + 0.75rem + 2px)"
                                            }}
                                        >
                                            Finalizar
                                        </Button>
                                    </VStack>
                                </VStack>
                            </VStack>
                        </VStack>
                        : <Button type="submit" variant="secondary" style={{ height: "calc(1.8em + 0.75rem + 2px)" }} py={'10px !important'}>Adjuntar</Button>
                    }

                </form>

            </VStack>
        </Box>


    )

};



export default FileUploadComponent;